import { nsUser } from '@/app/i18n/namespaces';
import USER_ADVANCED_AUTH from '../enums/UserAdvancedAuth';
import USER_STATUS from '../enums/UserStatus';

export default {
    UUID: {
        key: 'uuid',
        enableSorting: false
    },
    DETAILS: {
        key: 'details',
        enableSorting: false
    },
    ORGANIZATION_UUID: {
        key: 'organization'
    },
    EMAIL: {
        key: 'email',
        entity: 'keys.email',
        type: 'email',
        namespace: nsUser,
        placeholder: 'filter.placeholder.email',
        //validate: validateEmail,
        enableSorting: true,
        filter: 'input'
    },
    STATUS: {
        key: 'status',
        type: 'badge',
        entity: 'keys.status',
        namespace: nsUser,
        prefix: 'user_status_',
        enum: USER_STATUS,
        enableSorting: true,
        filter: 'select'
    },
    PASSWORD: {
        key: 'password',
        entity: 'user_password',
        type: 'password',
        //validate: password => password ? undefined : 'EMPTY_PASSWORD',
        isRequired: true
    },
    PASSWORD_CONFIRMATION: {
        key: 'passwordConfirmation',
        entity: 'user_password_confirmation',
        type: 'password',
        //validate: (passwordConfirmation, allValues = {}) => passwordConfirmation && passwordConfirmation === allValues.password ? undefined : 'PASSWORDS_DIFFERENT',
        // helpText: (values = {}) => {
        //     const { password, passwordConfirmation } = values;
        //     const passwordConfirmationIsEmpty = !passwordConfirmation;
        //     const passwordsMatch = passwordConfirmation === password;

        //     return passwordConfirmationIsEmpty || !passwordsMatch ? 'user_help_passwords_dont_match' : undefined;
        // },
        isRequired: true
    },
    TOTP: {
        key: 'totp',
        type: 'text',
        entity: 'user_totp'
        //validate: (totp) => (totp && /^\d{6}$/.test(totp)) ? undefined : 'REQUIRED'
    },
    CREATED_AT: {
        key: 'createdAt',
        type: 'date',
        namespace: nsUser,
        entity: 'keys.created_at',
        enableSorting: true,
        filter: 'date'
    },
    UPDATED_AT: {
        key: 'updatedAt',
        type: 'date',
        namespace: nsUser,
        entity: 'keys.updated_at',
        enableSorting: true,
        filter: 'date'
    },
    LAST_LOGIN_AT: {
        key: 'lastLoginAt',
        type: 'date',
        namespace: nsUser,
        entity: 'keys.last_login_at',
        enableSorting: true,
        filter: 'date'
    },
    PROFILE: {
        key: 'profileName',
        type: 'text',
        entity: 'keys.profile',
        namespace: nsUser,
        prefix: 'profile.',
        enableSorting: false
    },
    PERMISSIONS: {
        key: 'permissionList',
        type: 'text',
        entity: 'user_permissions',
        prefix: 'permissions_'
    },

    NEW_ACCOUNT: {
        key: 'newAccount'
    },
    ADVANCED_AUTH: {
        key: 'hasMfa',
        type: 'bool',
        entity: 'keys.has_mfa',
        tooltip: 'tooltip.has_mfa',
        namespace: nsUser,
        moreInfoEntity: 'user_has_mfa_extended',
        prefix: 'has_mfa.',
        enableSorting: true,
        enum: USER_ADVANCED_AUTH,
        filter: 'select'
    },
    ROLES: {
        key: 'roles'
    },
    PROFILE_NAME: {
        key: 'name'
    },
    PROFILE_PERMISSIONS: {
        key: 'permissions'
    },
    IS_PRELUDD: {
        key: 'isPreludd'
    },
    IS_DIRECT_PRELUDD_CLIENT: {
        key: 'isDirectPreluddClient'
    }
};